import { render, staticRenderFns } from "./CAOG1010.vue?vue&type=template&id=f3902474&scoped=true"
import script from "./CAOG1010Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAOG1010Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAOG1010.vue?vue&type=style&index=0&id=f3902474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3902474",
  null
  
)

export default component.exports